<script>
    export let step = 1;
    export let stepTitles = [];
    
</script>

<style>
    ul {
        margin: 2rem 0;
        padding-top: .8rem;
        padding-bottom: .8rem;
        position: sticky;
        top: 3rem;
        background: #fff;
        z-index: 10;
    }
    li {
        text-transform: capitalize;
    }
</style>

<ul class="w-full steps">
    {#each stepTitles as stepTitle, i}
        <li class="step {step > i ? "step-primary": ""}">
            { stepTitle.replace("Sense of ", "") }
        </li> 
    {/each}
  </ul>
  